import { Admin } from '@apis'
import { Button, Card, Row } from '@components'
import Fields from '@components/fields'
import {
  cardStyle,
  StyleCardTitle,
  StyleColumn,
  StyleNoteWrapper,
  StyleTypography,
} from '@components/styles'
import { AuthSchema } from '@validations'
import { Form, Formik } from 'formik'
import { Fragment, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const AdminChangePasswordForm = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const initialValues = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  }
  const submitHandler = async (values: any) => {
    setLoading(true)
    await Admin.changePassword(values)
      .then(() => {
        navigate('/admin/dashboard')
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <Fragment>
      <StyleCardTitle>Password & Security</StyleCardTitle>
      <Formik
        validationSchema={AuthSchema.resetPasswordValidationSchema}
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Card customStyle={cardStyle}>
                <StyleNoteWrapper>
                  <StyleTypography>
                    Your password must be at least 6 characters and should
                    include a combination of numbers, letters and special
                    characters (!$@%).
                  </StyleTypography>
                </StyleNoteWrapper>
                <StyleColumn>
                  <Row>
                    <Fields.Password
                      name="currentPassword"
                      label="Enter Current Password"
                      placeholder="Enter Current Password"
                    />
                  </Row>
                  <Row>
                    <Fields.Password
                      name="newPassword"
                      label="Enter New Password"
                      placeholder="Enter New Password"
                    />
                  </Row>
                  <Row>
                    <Fields.Password
                      name="confirmPassword"
                      label="Enter Confirm Password"
                      placeholder="Enter Confirm Password"
                    />
                  </Row>
                </StyleColumn>
                <Row>
                  <Button
                    type="submit"
                    title={!!loading ? 'Updating....' : 'Change Password'}
                    height={40}
                    styleButtonWrapper="margin-top:20px;margin-left:auto"
                    disabled={loading}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </Fragment>
  )
}

export default AdminChangePasswordForm
